

angular
.module('inkfinder')
.factory('GetAppointmentShop', function GetAppointmentShop(
  Shop,
  $q,
  _
) {
  // Public methods
  GetAppointmentShop.get = get;
  /**
   * @name get
   * @description Function to get and set the shop object on appointments.
   * @param {array} collection The collection of appointments containing shop
   * IDs.
   * @return {array} appointmentsWithShops Returns the grouped collection.
   */
  function get(collection) {
    if (_.isArray(collection)) {
      let promises = [];
      _.each(collection, function(appointment) {
        let promise = Shop.get(appointment.shop);
        promises.push(promise);
      });
      return $q.all(promises);
    }
    return Shop.get(collection.shop);
  }
  return GetAppointmentShop;
});



// WEBPACK FOOTER //
// ./components/shop/util/get-appointment.shop.js